import React from 'react'
import ReactDOM from 'react-dom'
import './index.scss'
import App from './App'
import { store } from './app/store'
import { Provider } from 'react-redux'
import * as serviceWorker from './serviceWorker'
// CONFIG ANTD
import 'antd/dist/antd.css'
import 'moment/locale/vi'
import viVN from 'antd/lib/locale/vi_VN'
import moment from 'moment'
import { ConfigProvider } from 'antd'
import { Router } from 'react-router-dom'
import history from './services/history'

moment.locale('vi_VN')

ReactDOM.render(
  <React.StrictMode>
    <Router history={history}>
      <Provider store={store}>
        <ConfigProvider locale={viVN}>
          <App />
        </ConfigProvider>
      </Provider>
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
